import {types} from '../../../univers/ui/authentication/services/login/loginActions'
import {types as userTypes} from './userEEActions'
import {getListCompany} from '../../../kpi/ui/listCompany/ListCompanyActions'

export const user = (state = null, action) => {
    switch (action.type) {
        case types.LOG_USER: {
            if (action.payload) {
                return action.payload.user
            }
            return state
        }
        case userTypes.SET_USER_MAIL: {
            return {
                ...state,
                email: action.payload
            }
        }
        default:
            return state
    }
}
